<template>
  <v-window-item value="educations">
    <v-card-text>
      <v-card
        v-for="education in userEducationInfoData"
        :key="education.id"
        variant="outlined"
        class="mb-4"
      >
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-school-outline</v-icon>
          {{ education.level || 'N/A' }} - {{ education.examination || 'N/A' }}
        </v-card-title>

        <v-card-text>
          <v-card variant="tonal" class="py-4">
            <v-row>
              <v-col cols="12" md="6">
                <v-list-item
                  prepend-icon="mdi-format-list-bulleted-type"
                  title="Education Level"
                  :subtitle="(education.level) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-book-education-outline"
                    title="Examination"
                    :subtitle="(education.examination) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-school-outline"
                    title="Institution"
                    :subtitle="(education.institution) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-calendar-check-outline"
                    title="Passing Year"
                    :subtitle="(education.passing_year) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-bank-outline"
                    title="Board"
                    :subtitle="(education.board) || 'N/A'"
                />

              </v-col>

              <v-col cols="12" md="6">
                <v-list-item
                    prepend-icon="mdi-book-open-variant"
                    title="Subject Group"
                    :subtitle="(education.subject_group) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-chart-line"
                    title="Marks / GPA"
                    :subtitle="(education.marks_gpa) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-medal-outline"
                    title="Result"
                    :subtitle="(education.result) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-file-certificate-outline"
                    title="Certificate File"
                    :subtitle="(education.certificate_file) || 'N/A'"
                />

                <v-list-item
                    prepend-icon="mdi-file-document-outline"
                    title="Transcript File"
                    :subtitle="(education.transcript_file) || 'N/A'"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>

      <v-alert
        v-if="userEducationInfoData.length === 0"
        type="info"
        variant="tonal"
      >
        No educational information found.
      </v-alert>
    </v-card-text>
  </v-window-item>
</template>

<script setup>
defineProps({
  userEducationInfoData: {
    type: Array,
    default: () => []
  }
})
</script>
